<template>
    <div class="modal fade" id="serverErrorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog coupon-modal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <span class="text-red" style="text-transform: capitalize; font-family: AvertaBlack; font-size: 38px; margin-bottom: 10px;">Ooops!</span>

                    <p class="text-red">
                        Något gick fel!
                    </p>

                    <button @click="navigateToAllCampaigns" class="btn btn-danger">Hitta fler rabatter</button>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        methods: {
            navigateToAllCampaigns () {
                $('.modal').modal('hide');
                this.$router.push({ name: 'all-campaigns' });
            }
        }
    }
</script>
